import { hasValue } from '@famly/stat_ts-utils_has-value';
import ENV from './environment';
import { getConfig } from './white-labeling-constants';
import whitelabelConfigs from '../../whitelabel/whitelabel-config.json';
export const OVERRIDE_WHITE_LABEL_KEY = 'famly.OVERRIDE_WHITE_LABEL_KEY';
let _determinedWhitelabel;
const determineWhitelabel = () => {
    var _a;
    let overriddenWhitelabel = null;
    try {
        overriddenWhitelabel = (_a = window.sessionStorage) === null || _a === void 0 ? void 0 : _a.getItem(OVERRIDE_WHITE_LABEL_KEY);
    }
    catch (_b) {
        // sessionStorage access may be blocked (e.g., cross-origin iframe, Safari private mode)
    }
    if (hasValue(overriddenWhitelabel) && isValidWhitelabelKey(overriddenWhitelabel)) {
        return overriddenWhitelabel;
    }
    const isWhitelabel = whitelabels.find(whitelabel => {
        return window.location.host.endsWith(getConfig(whitelabel, 'domain')) || ENV.WHITELABEL_APP_ID === whitelabel;
    });
    if (isWhitelabel) {
        return isWhitelabel;
    }
    return null;
};
export const whitelabels = Object.keys(whitelabelConfigs);
const isValidWhitelabelKey = (whitelabel) => {
    return whitelabels.includes(whitelabel);
};
export const getWhitelabel = () => {
    if (_determinedWhitelabel !== undefined) {
        return _determinedWhitelabel;
    }
    else {
        const whitelabel = determineWhitelabel();
        _determinedWhitelabel = whitelabel;
        return _determinedWhitelabel;
    }
};
export const overrideWhitelabel = (whitelabelKey) => {
    if (!isValidWhitelabelKey(whitelabelKey)) {
        return;
    }
    try {
        window.sessionStorage.setItem(OVERRIDE_WHITE_LABEL_KEY, whitelabelKey);
    }
    catch (_a) {
        // sessionStorage access may be blocked (e.g., cross-origin iframe, Safari private mode)
    }
};
/**
 * These ids maps to how the backend configures push notifications.
 * We send this ID along with the push notification token when we register the app installation
 * for push notifications in the backend.
 *
 * When inserting new whitelabel apps, generate a random UUID, and communicate that to the backend
 * that's responsible for configuring the push notifications.
 */
export const getWhitelabelPushAppId = () => {
    const whitelabel = getWhitelabel();
    if (whitelabel) {
        const pushAppId = getConfig(whitelabel, 'pushAppId');
        if (pushAppId) {
            return pushAppId;
        }
    }
    return getConfig('famly', 'pushAppId');
};
/**
 * The value returned from this is used wherever we mention the "product name".
 */
export const getWhitelabelName = () => {
    const whitelabel = getWhitelabel();
    if (whitelabel) {
        return getConfig(whitelabel, 'title');
    }
    return 'Famly';
};
export const getWhitelabelUrl = () => {
    const whitelabel = getWhitelabel();
    return whitelabel ? getConfig(whitelabel, 'domain') : null;
};
export const getWhitelabelMobileAppUrl = () => {
    const whitelabel = getWhitelabel();
    if (whitelabel) {
        return getConfig(whitelabel, 'app_url_scheme');
    }
    return getConfig('famly', 'app_url_scheme');
};
export const isWhitelabelRingfenced = () => {
    const whitelabel = getWhitelabel();
    if (whitelabel === null) {
        return false;
    }
    return Boolean(getConfig(whitelabel, 'isRingfenced'));
};
